import {
  BonusBalanceUpdateResponse,
  IdentificationStatusChangeResponse,
  RegistrationSourceResponse,
  User,
  UserBonusWalletResponse,
  UserCosmeticUpdateResponse,
  UserResponse,
  WalletBalanceUpdateResponse,
} from '@/interfaces/user';

export const GET_ANONYMOUS_USER = 'user/GET_ANONYMOUS_USER' as const;
export const SET_USER = 'user/SET_USER' as const;
export const SET_USER_NEW_REGISTRATION = 'user/SET_USER_NEW_REGISTRATION' as const;
export const SET_USER_REGISTRATION_SOURCE = 'user/SET_USER_REGISTRATION_SOURCE' as const;
export const GET_USER_BONUS_WALLET = 'user/GET_USER_BONUS_WALLET' as const;
export const SET_USER_BONUS_WALLET = 'user/SET_USER_BONUS_WALLET' as const;
export const UPDATE_VERIFY_USER = 'user/UPDATE_VERIFY_USER' as const;
export const UPDATE_NOT_NEW_USER = 'user/UPDATE_NOT_NEW_USER' as const;
export const UPDATE_USER = 'user/UPDATE_USER' as const;
export const UPDATE_USER_ID_STATUS = 'user/UPDATE_USER_ID_STATUS' as const;
export const UPDATE_USER_WALLET = 'user/UPDATE_USER_WALLET' as const;
export const UPDATE_USER_BONUS_CASH = 'user/UPDATE_USER_BONUS_CASH' as const;
export const UPDATE_USER_COSMETIC = 'user/UPDATE_USER_COSMETIC' as const;

export const setUser = (payload: User) => ({ type: SET_USER, payload });

export const getAnonymousUser = () => {
  return { type: GET_ANONYMOUS_USER };
};

export const getUserBonusWallet = () => ({ type: GET_USER_BONUS_WALLET });

export const setUserBonusWallet = (payload: UserBonusWalletResponse) => {
  return {
    type: SET_USER_BONUS_WALLET,
    payload,
  };
};

export const updateVerifyUser = (payload: { data: UserResponse }) => ({
  type: UPDATE_VERIFY_USER,
  payload,
});

export const updateNotNewUser = () => ({ type: UPDATE_NOT_NEW_USER });

export const updateUserIdStatus = (payload: IdentificationStatusChangeResponse) => ({
  type: UPDATE_USER_ID_STATUS,
  payload,
});

export const updateUserWallet = (payload: WalletBalanceUpdateResponse) => ({
  type: UPDATE_USER_WALLET,
  payload,
});

export const updateUserBonusCash = (payload: BonusBalanceUpdateResponse) => ({
  type: UPDATE_USER_BONUS_CASH,
  payload,
});

export const updateUserCosmetic = (payload: UserCosmeticUpdateResponse) => ({
  type: UPDATE_USER_COSMETIC,
  payload,
});

export const setUserRegistrationSource = (payload: RegistrationSourceResponse) => ({
  type: SET_USER_REGISTRATION_SOURCE,
  payload,
});

export const setUserNewRegistration = () => {
  return { type: SET_USER_NEW_REGISTRATION };
};

/**
 * Caution: this action does not deeply merge the payload with the existing user state,
 * it will only update/assign top-level properties. Nested properties and arrays will
 * not be merged.
 */
export const updateUser = (payload: Partial<User>) => {
  return {
    type: UPDATE_USER,
    payload,
  };
};
